"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

// Always lazy-load the CodeEditor component
// This reduces the main bundle size by ~389KB
var _default = (0, _DynamicImport.default)(function () {
  return import('./CodeEditor');
});

exports.default = _default;